import {Component, OnInit} from '@angular/core';
import {CommunicationService} from '../../../../core/services/communication.service';
import {fuseAnimations} from '../../../../core/animations';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
    selector: 'email-editor',
    templateUrl: './emailEditor.component.html',
    styleUrls: ['./emailEditor.component.scss'],
    animations: fuseAnimations,
    standalone: false
})

export class EmailEditorComponent implements OnInit{
  data = [];
  mailBodyHeader = '';
  mailBodyBetween = '';
  mailBodyFooter = '';
  allMailBody: any = '';

  constructor(private communicationService: CommunicationService,
              private sanitizer: DomSanitizer) {

  }

  ngOnInit() {
    this.getEmailEditorData();
  }

  getEmailEditorData() {
    this.communicationService.getEmailEditorData().subscribe((res: any) => {
      if (res) {
        this.data = res;
        this.setData();
      }
    });
  }

  changeData(id, data, type) {
    let index = this.data.findIndex(el => +el.id === +id);
    if (index !== undefined) {
      this.data[index][type] = data;
      this.setData();
    }
  }

  saveEmails() {
    console.log(this.data);
    this.communicationService.saveEmailEditorData(this.data).subscribe(res => {

    });
  }

  setData() {
    const headerColor = this.data.find(el => el.type === 'color').data;
    const mainLogo = this.data.find(el => el.type === 'header_logo').data;
    let footerInfo = this.data.map(el => {
      if (el.type === 'footer_image') {
        return el;
      }
    }).filter(el => el);
    const footerData = this.data.find(el => el.type === 'email_footer').data;
    let htmlFooter = '';
    if (footerInfo && footerInfo.length) {
      for (let i = 0; i < footerInfo.length; i++) {
        htmlFooter = htmlFooter + `<table cellpadding="0" cellspacing="0" class="es-left" align="left" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;float:left;">
        <tr style="border-collapse:collapse;">
        <td width="165" class="es-m-p0r es-m-p20b" align="center" style="padding:0;Margin:0;">
        <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
        <tr style="border-collapse:collapse;">
        <td align="center" style="padding:0;Margin:0;"> <a target="_blank" href="${footerInfo[i].link}" style="-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-size:14px;text-decoration:underline;color:#1376C8;">  <img class="adapt-img" src="${footerInfo[i].data}" alt="" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;" width="65"></a> </td>
        </tr>
        </table> </td>
        <td class="es-hidden" width="20" style="padding:0;Margin:0;"></td>
          </tr>
          </table>`
      }
    }
    this.mailBodyHeader = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
 <html style="width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0;">
 <head>
     <meta charset="UTF-8">
 <meta content="width=device-width, initial-scale=1" name="viewport">
 <meta name="x-apple-disable-message-reformatting">
 <meta http-equiv="X-UA-Compatible" content="IE=edge">
 <meta content="telephone=no" name="format-detection">
     <title></title>
     <!--[if (mso 16)]>
 <style type="text/css">
     a {text-decoration: none;}
 </style>
 <![endif]-->
 <!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
 <style type="text/css">
     @media only screen and (max-width:600px) {p, ul li, ol li, a { font-size:16px!important } h1 { font-size:30px!important; text-align:center } h2 { font-size:26px!important; text-align:center } h3 { font-size:20px!important; text-align:center } h1 a { font-size:30px!important } h2 a { font-size:26px!important } h3 a { font-size:20px!important } .es-menu td a { font-size:16px!important } .es-header-body p, .es-header-body ul li, .es-header-body ol li, .es-header-body a { font-size:16px!important } .es-footer-body p, .es-footer-body ul li, .es-footer-body ol li, .es-footer-body a { font-size:16px!important } .es-infoblock p, .es-infoblock ul li, .es-infoblock ol li, .es-infoblock a { font-size:12px!important } *[class="gmail-fix"] { display:none!important } .es-m-txt-c, .es-m-txt-c h1, .es-m-txt-c h2, .es-m-txt-c h3 { text-align:center!important } .es-m-txt-r, .es-m-txt-r h1, .es-m-txt-r h2, .es-m-txt-r h3 { text-align:right!important } .es-m-txt-l, .es-m-txt-l h1, .es-m-txt-l h2, .es-m-txt-l h3 { text-align:left!important } .es-m-txt-r img, .es-m-txt-c img, .es-m-txt-l img { display:inline!important } .es-button-border { display:block!important } .es-button { font-size:20px!important; display:block!important; border-left-width:0px!important; border-right-width:0px!important } .es-btn-fw { border-width:10px 0px!important; text-align:center!important } .es-adaptive table, .es-btn-fw, .es-btn-fw-brdr, .es-left, .es-right { width:100%!important } .es-content table, .es-header table, .es-footer table, .es-content, .es-footer, .es-header { width:100%!important; max-width:600px!important } .es-adapt-td { display:block!important; width:100%!important } .adapt-img { width:100%!important; height:auto!important } .es-m-p0 { padding:0px!important } .es-m-p0r { padding-right:0px!important } .es-m-p0l { padding-left:0px!important } .es-m-p0t { padding-top:0px!important } .es-m-p0b { padding-bottom:0!important } .es-m-p20b { padding-bottom:20px!important } .es-mobile-hidden, .es-hidden { display:none!important } .es-desk-hidden { display:table-row!important; width:auto!important; overflow:visible!important; float:none!important; max-height:inherit!important; line-height:inherit!important } .es-desk-menu-hidden { display:table-cell!important } table.es-table-not-adapt, .esd-block-html table { width:auto!important } table.es-social { display:inline-block!important } table.es-social td { display:inline-block!important } }
 #outlook a {
     padding:0;
 }
 .ExternalClass {
     width:100%;
 }
 .ExternalClass,
 .ExternalClass p,
 .ExternalClass span,
 .ExternalClass font,
 .ExternalClass td,
 .ExternalClass div {
     line-height:100%;
 }
 .es-button {
     mso-style-priority:100!important;
     text-decoration:none!important;
 }
 a[x-apple-data-detectors] {
     color:inherit!important;
     text-decoration:none!important;
     font-size:inherit!important;
     font-family:inherit!important;
     font-weight:inherit!important;
     line-height:inherit!important;
 }
 .es-desk-hidden {
     display:none;
     float:left;
     overflow:hidden;
     width:0;
     max-height:0;
     line-height:0;
     mso-hide:all;
 }
 
 </style>
 </head>
 <body style="width:100%;font-family:arial, 'helvetica neue', helvetica, sans-serif;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;padding:0;Margin:0;">
 <div class="es-wrapper-color" style="background-color:#F6F6F6;">
     <!--[if gte mso 9]>
 <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
     <v:fill type="tile" color="#f6f6f6"></v:fill>
 </v:background>
 <![endif]-->
 <table cellpadding="0" cellspacing="0" class="es-wrapper" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;padding:0;Margin:0;width:100%;height:100%;background-repeat:repeat;background-position:center top;">
 <tr style="border-collapse:collapse;">
 <td valign="top" style="padding:0;Margin:0;">
 <table cellpadding="0" cellspacing="0" class="es-content" align="center" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;table-layout:fixed !important;width:100%;">
 <tr style="border-collapse:collapse;">
 <td align="center" bgcolor="transparent" style="padding:0;Margin:0;background-color:transparent;background-position:left top;">
 <table class="es-content-body" align="center" cellpadding="0" cellspacing="0" width="600" bgcolor="#${headerColor}" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;background-color:#${headerColor};">
 <tr style="border-collapse:collapse;">
 <td align="left" style="padding:0;Margin:0;">
 <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
 <tr style="border-collapse:collapse;">
 <td class="es-m-p20b" width="600" align="left" style="padding:0;Margin:0;">
 <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
 <tr style="border-collapse:collapse;">
 <td align="center" style="padding:30px;Margin:0">   <img class="adapt-img" src="${mainLogo}" alt="" style="display:block;border:0;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic;" width="452"></td>
 </tr>
 <tr style="border-collapse:collapse;">
 <td align="center" bgcolor="#ffffff" style="padding:0;Margin:0;padding-top:10px;padding-bottom:15px;"> <h2 style="Margin:0;line-height:29px;mso-line-height-rule:exactly;font-family:arial, 'helvetica neue', helvetica, sans-serif;font-size:24px;font-style:normal;font-weight:normal;color:#333333;">`;
    this.mailBodyBetween = `</h2> </td>
 </tr>
 <tr style="border-collapse:collapse;">
 <td  bgcolor="#ffffff" style="padding:0;Margin:0;padding-top:20px;padding-bottom:20px;"> <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:14px;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:21px;color:#333333;">`
    this.mailBodyFooter =  `</p> </td>
    </tr>
    <tr style="border-collapse:collapse;">
    <td style="padding:0;Margin:0;">
    <table width="100%" cellspacing="0" cellpadding="0" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
    </table> </td>
    </tr>
    </table> </td>
    </tr>
    </table> </td>
    </tr>
    <tr style="border-collapse:collapse;">
    <td align="left" bgcolor="#ffffff" style="padding:0;Margin:0;padding-bottom:5px;padding-left:20px;padding-right:20px;background-color:#FFFFFF;background-position:left top;">
    <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
    <tr style="border-collapse:collapse;">
    <td width="560" align="center" valign="top" style="padding:0;Margin:0;">
    <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
    <tr style="border-collapse:collapse;">
    <td align="center" style="padding:10px;Margin:0;">  </td>
    </tr>
    </table> </td>
    </tr>
    </table> </td>
    </tr>
    <tr style="border-collapse:collapse;">
    <td align="left" style="Margin:0;padding-bottom:10px;padding-top:20px;padding-left:20px;padding-right:20px;background-position:left top;">
      <!--[if mso]><table width="560" cellpadding="0"
    cellspacing="0"><tr><td width="145" valign="top"><![endif]-->
    ${htmlFooter}
      <!--[if mso]></td></tr></table><![endif]--> </td>
    </tr>
    <tr style="border-collapse:collapse;"  class="white-text">
    <td align="left" style="padding:0;Margin:0;padding-bottom:20px;padding-left:20px;padding-right:20px;background-position:left top;">
    <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
    <tr style="border-collapse:collapse;">
    <td width="560" align="center" valign="top" style="padding:0;Margin:0;">
    <table cellpadding="0" cellspacing="0" width="100%" style="mso-table-lspace:0pt;mso-table-rspace:0pt;border-collapse:collapse;border-spacing:0px;">
    <tr style="border-collapse:collapse;">
    <td align="center" style="padding:0;Margin:0;"> <p style="Margin:0;-webkit-text-size-adjust:none;-ms-text-size-adjust:none;mso-line-height-rule:exactly;font-size:16px;font-family:arial, 'helvetica neue', helvetica, sans-serif;line-height:24px;color:#FFFFFF;">${footerData}</a></p> </td>
      </tr>
      </table> </td>
      </tr>
      </table> </td>
      </tr>
      </table> </td>
      </tr>
      </table> </td>
      </tr>
      </table>
      </div>
      </body>
      </html>`;
    this.allMailBody = this.sanitizer.bypassSecurityTrustHtml(this.mailBodyHeader + '' +
      this.mailBodyBetween + '' + this.mailBodyFooter);
  }
}
